import React, { useEffect } from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import ContactHero from "./ContactHero";
import ContactForm from "./ContactForm";
import ContactDetails from "./ContactDetails";

function ContactUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contact-us-page">
      <Header />
      <ContactHero />
      <ContactForm />
      <ContactDetails />
      <Footer />
    </div>
  );
}

export default ContactUs;
